export default __webpack_public_path__ + "static/media/Up-2.a5aab2b6.svg";